module.exports = __webpack_public_path__ + "static/media/Personalization.a71b805a.svg";